import { IconButton } from 'components'
import TextInput from 'components/elements/TextInput'
import { addDays, format } from 'date-fns'
import { useEffect, useState } from 'react'
import { DateRange } from 'react-date-range'
import { ko } from 'react-date-range/dist/locale'
import { useRecoilValue } from 'recoil'
import { backPressState } from 'store/atom/app-state-atom'

// react-date-range
import 'react-date-range/dist/styles.css'
//import 'react-date-range/dist/theme/default.css'

// css
import 'assets/css/calendar.css'
import 'assets/style/elements/datepicker.scss'

function Element({
  className = '',
  placeholder = 'yyyy.mm.dd ~ yyyy.mm.dd',
  dateFormat = 'yyyy.MM.dd',
  disabled = false,
  dateRange = {
    startDate: addDays(new Date(), -7),
    endDate: new Date(),
  },
  changeDate = () => {},
  changeToPropsState = false,
}) {
  const [calShow, setCalShow] = useState(false)
  const [date, setDate] = useState('')
  const [state, setState] = useState({ ...dateRange, key: 'dateSelection' })

  const backPress = useRecoilValue(backPressState)

  useEffect(() => {
    if (calShow) {
      setCalShow(false)
    }
  }, [backPress])

  const handleCal = () => {
    if (disabled) return
    setCalShow(!calShow)
  }

  const handleDate = (date) => {
    const { startDate, endDate } = date

    setState(date)

    changeDate(startDate, endDate)
  }

  const changeText = () => {
    const { startDate, endDate } = state
    const start = format(startDate, dateFormat)
    const end = format(endDate, dateFormat)
    setDate(`${start} ~ ${end}`)
  }

  // useEffect(changeText, [])
  useEffect(changeText, [state])

  useEffect(() => {
    if (changeToPropsState) setState({ ...dateRange, key: 'dateSelection' })
  }, [dateRange])

  return (
    <>
      <div onClick={handleCal} className={className}>
        <TextInput
          icon="date"
          value={date}
          placeholder={placeholder}
          readOnly={true}
          onClick={handleCal}
          iconOnClick={handleCal}
        />
      </div>
      <div className={`calendar-modal ${calShow === true ? 'show' : 'hide'}`}>
        <div className="popup-dim" onClick={handleCal}></div>
        <div className="calendar-wrap">
          <header className={`site-header site-header-popup`} style={{ padding: '0', height: '25px' }}>
            <div className="row relative" style={{ height: '26px', backgroundColor: '#ffffff' }}>
              <div className="right" style={{ top: '0px' }}>
                <IconButton size="20" bg="white" type="close" onClick={handleCal} />
              </div>
            </div>
          </header>
          <DateRange
            editableDateInputs={true}
            onChange={(item) => {
              handleDate(item.dateSelection)
            }}
            onRangeFocusChange={(item) => {
              if (item[1] === 0) handleCal()
            }}
            moveRangeOnFirstSelection={false}
            ranges={[state]}
            dateDisplayFormat={dateFormat}
            locale={ko}
            showDateDisplay={false}
          />
        </div>
      </div>
    </>
  )
}

export default Element
